import type { HTMLAttributes } from 'react'

import styles from './Surface.module.css'

/**
 * Уровни поверхности. Шесть вместо двух, которые были в старом CSS.
 *
 * В тёмном интерфейсе тень почти не читается, поэтому глубина передаётся
 * осветлением поверхности и полоской света сверху — а не только тенью.
 */
export type SurfaceLevel = 'sunken' | 'base' | 'raised' | 'glass'

export interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  level?: SurfaceLevel
  /** Золотая рамка. Для того, что относится к самим картам. */
  sacred?: boolean
  padded?: boolean
}

export function Surface({
  level = 'base',
  sacred = false,
  padded = true,
  className,
  ...rest
}: SurfaceProps) {
  const classes = [
    styles.surface,
    styles[`l-${level}`],
    sacred ? styles.sacred : null,
    padded ? styles.padded : null,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return <div className={classes} {...rest} />
}
